import { Injectable } from '@angular/core';
import { IConversion } from '../models/i-conversion';

@Injectable({
  providedIn: 'root'
})
export class ArrayBufferToBinaryStringConversionService implements IConversion<ArrayBuffer, string> {
  constructor() { }

  run(source) {
    return String.fromCharCode.apply(null, new Uint8Array(source));
  }
}
